import { useState, useEffect } from "react";
import { listenToOrders } from "../services/orderService";

export function useOrders() {
  const [orders,  setOrders]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    const unsubscribe = listenToOrders((liveOrders) => {
      setOrders(liveOrders);
      setLoading(false);
      setError(null);
    });
    return () => unsubscribe();
  }, []);

  const pendingOrders   = orders.filter(o => o.status === "Pending");
  const completedOrders = orders.filter(o => o.status === "Completed");
  const totalRevenue    = completedOrders.reduce((sum, o) => sum + (o.amount || 0), 0);

  return {
    orders,
    loading,
    error,
    pendingOrders,
    completedOrders,
    totalRevenue,
    totalCount: orders.length,
  };
}